export default {
  createButton: { id: 'create_button' },
  sisenseDashboardList: { id: 'sisense_dashboard_list' },
  sisenseDashboard: { id: 'sisense_dashboard' },
  application: { id: 'application' },
  licensees: { id: 'licensees' },
  sisenseDashboardInfo: { id: 'sisense_dashboard_info' },
  createSisenseDashboard: { id: 'create_sisense_dashboard' },
  editSisenseDashboard: { id: 'edit_sisense_dashboard' },
  deleteSisenseDashboard: { id: 'delete_sisense_dashboard' },
  deleteSisenseDashboardMessage: { id: 'delete_sisense_dashboard_message' },
  name: { id: 'name' },
  embedLink: { id: 'embed_link' },
  parameters: { id: 'parameters' },
  dateUpdated: { id: 'date_updated' },
  orderNumber: { id: 'order_number' },
}
